import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin, Radio } from 'antd'
import { PlusOutlined, PauseOutlined } from '@ant-design/icons'
import { DualAxes } from '@antv/g2plot';
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'
import styles from '../../style.module.less'

const tabsOptions = [
  {
    label: '按公司',
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    column: null as DualAxes,
    loadTime: updateTime
  })

  const getData = useCallback(async () => {
    
  }, [])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getData()
  }, [getData])

  return (
    <Spin spinning={loading}>
      <CardContainer
          tabs={tabsOptions}
          onTabChange={handleTabChange}
          hasExport={false}
          hasDepartSelect
        >
          <div className='flex mt-30 mlr-10 align-center space-between' style={{maxWidth: '1500px'}}>
            <div className={`${styles['item-tag']} font-16 pt-4`}>总成本支出</div>
            <div className='ml-20 mr-20'>
              <div className='text-999'>本年总成本支出</div>
              <div>
                <span className={`${styles['item-value']} font-28 font-700`}>27.38</span>
                <span className='font-12 ml-6'>万</span>
              </div>
            </div>
            <div className={styles['item-equal']}>
              <PauseOutlined />
            </div>
            <div className='ml-10'>
              <div className='text-999'>项目相关成本</div>
              <div>
                <span className={`${styles['green-item']} font-28 font-700`}>16.86</span>
                <span className='font-12 ml-6'>万</span>
              </div>
            </div>
            <div className={`flex ${styles['item-group']} space-around ml-10`}>
              <div className='mlr-10'>
                <div className='text-999'>地基基础劳务</div>
                <div>
                  <span className={` font-22 font-700`}>8.60</span>
                  <span className='font-12 ml-6'>万</span>
                </div>
              </div>
              <div className='mlr-10'>
                <div className='text-999'>普通劳务</div>
                <div>
                  <span className={` font-22 font-700`}>8.60</span>
                  <span className='font-12 ml-6'>万</span>
                </div>
              </div>
              <div className='mlr-10'>
                <div className='text-999'>劳务配合</div>
                <div>
                  <span className={` font-22 font-700`}>8.60</span>
                  <span className='font-12 ml-6'>万</span>
                </div>
              </div>
              <div className='mlr-10'>
                <div className='text-999'>外协费</div>
                <div>
                  <span className={` font-22 font-700`}>8.60</span>
                  <span className='font-12 ml-6'>万</span>
                </div>
              </div>  
            </div>
            <div className={styles['item-equal']}>
              <PlusOutlined />
            </div>
            <div>
              <div className='text-999'>人力成本</div>
              <div>
                <span className={`${styles['qing-item']} font-28 font-700`}>27.38</span>
                <span className='font-12 ml-6'>万</span>
              </div>
            </div>
            <div className={styles['item-equal']}>
              <PlusOutlined />
            </div>
            <div>
              <div className='text-999'>其他成本</div>
              <div>
                <span className={`${styles['orange-item']} font-28 font-700`}>27.38</span>
                <span className='font-12 ml-6'>万</span>
              </div>
            </div>
          </div>
        </CardContainer>
    </Spin>
  )
}

export default Component
